/* eslint-disable react/sort-comp */
/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import {
  Button,
  Table,
  TableContainer,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  Loading,
  TableCell,
  TableToolbar,
  DataTableSkeleton,
} from 'carbon-components-react';
import Add16 from '@carbon/icons-react/lib/add/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';

import '../../scss/custom.scss';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  apioperation,
  entitiesLabels,
} from '../../helpers/Constants';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';
import { ConfirmAlertCustom } from '../../helpers/ConfirmAlertCustom';
import SimpleReactValidator from 'simple-react-validator';
import { Online } from '../common/OnLineOffLine';
import EnergyAccountLeasedAssetModal from './EnergyAccountLeasedAssetModal';
import ReportRepository from '../../helpers/api/ReportRepository';

export default class EnergyAccountLeasedAssetList extends Component {

    initialState = (props) => {
    const initialState = {

      // modal insert/edit
      keyModalLeasedAsset: `modalLeasedAsset_${new Date().getTime()}`,
      editModelLeasedAsset: null,
      isEditModalLeasedAsset: false,
      isOpenModalLeasedAsset: false,
      //addCountItems: 0,
      isWarningModalOpen : false,
      isOpenDeleteModal: false,
      isDeleting: false,
      idToDelete: false,
      isSubmitted: false,
      leasedAssetList: null,
      leasedAssetMatrix: null
    };
    return initialState;
  };

  constructor(props) {
    super(props);

    this.state = {
       ...this.initialState(props),
    };
    this.geqValidator = {
      message: 'The value must be greater than or equal to zero',
      rule: (val, params, validator) => {
        return +val >= 0;
      },
    };
    this.validator = new SimpleReactValidator({
      validators: {
        geq: this.geqValidator,
        req: {
          message: 'The :attribute is required and can\'t be null',
          rule: (val, params, validator) => {
            return val !== '';
          },
          required: true
        }
      },
    });

  }

  componentDidMount() {
    this.getListLeasedAssetReportDataFromReport();
    //this.getListLeasedAssetReportData();
    //this.initializeLeasedAsset();
  }

  getListLeasedAssetReportDataFromReport = () => {
    if (this.props.report) {
      this.setState((prevState)  => {
        return {leasedAssetList : this.props.report.leasedAssetReportData};
      });
    }
  }

  getListLeasedAssetReportData = () => {
    ReportRepository.getListLeasedAssetReportData(this.props.idReport)
    .then((response) => {
      this.setState((prevState)  => {
        return {leasedAssetList : response.itemList};
      });
    })
    .catch((error) => {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, entitiesLabels.ENVIROMENT, apioperation.GET)
      );
    });
  }

  updateListLeasedAssetReportData = (obj) => {
    let items = this.state.leasedAssetList;

    //Case Delete
    if (obj.idReportEnvironment == null) {
      /*
      const index = items.findIndex((item) => item.id == obj);
      
      this.repository.updateCachedCaList(
        items[index],
        this.state.idAuditEdit,
        this.state.idAnswer,
        true
      );
      */
      items = items.filter((x) => x.id != obj);
    } 
    else {
      const index = items.findIndex((item) => item.id === obj.id);
      if (index < 0) {
        items = items.concat([obj]);
/*         this.setState({
          rowCount: this.state.rowCount + 1,
        }); */
      } 
      else 
        items[index] = obj;
      
      this.setState({
        keyModalLeasedAsset: `modalLeasedAsset_${new Date().getTime()}`,
      });
      //this.repository.updateCachedCaList(caModel, this.state.idAuditEdit, this.state.idAnswer);
    }
    this.setState((prevState)  => {
      return {leasedAssetList : items};
    });
      
  };

  /*
  getCAs = (model) => this.props.getCAs(model);


  detailCA = (id) => {
    this.props.history.push(this.baseUrl + id);
  };
*/
  toggleWarningModal = () => {
    this.setState((prevState) => {return {isWarningModalOpen: !prevState.isWarningModalOpen };} );
  };

  handleConfirmSubmit = () => {
    this.setState(() =>
      {
        return {isWarningModalOpen: false}
      });
    this.onSaveModalLeasedAsset(true);
  };

  toggleModalLeasedAsset = (open) => {
    this.setState({ isOpenModalLeasedAsset: open });
  };

  addLeasedAsset = () => {
    this.initializeLeasedAsset();
    this.setState({ keyModalLeasedAsset: `modalLeasedAsset_${new Date().getTime()}`, isEditModalLeasedAsset: false, isOpenModalLeasedAsset: true, editModelLeasedAsset: {id: null, idReportEnvironment: null, name: null, notes: null}} );
  };

  initializeLeasedAsset = (leasedAssetData ) => {
    const leasedAssetMatrix = this.props.buildTwoLevelStructure(this.props.leasedAssetSchema, false);

    if (leasedAssetData && leasedAssetData.leasedAsset) {
      leasedAssetData.leasedAsset.forEach((e) => {
        leasedAssetMatrix[e.idEnergySourceType][e.idEnergyUsageType] = e.value;
      });
    }
    const informativeonlyIds = this.props.leasedAssetSchema.rows
      .filter((r) => r.informativeonly)
      .map((r) => r.id);
    
    informativeonlyIds.forEach((i) => {
      Object.keys(leasedAssetMatrix[i]).forEach((key) => {
        leasedAssetMatrix[i][key] = leasedAssetMatrix[i][key] || 0;
      });
    });
   
    this.setState({ leasedAssetMatrix });
  }

  getItem = ({id, idReportEnvironment, name, notes}) => {
    return {id , idReportEnvironment, name, notes};
  }

  editModalLeasedAsset = (id) => {
    if (id == null) return;
    this.setState ((prevState) => {
      return {isSubmitted: true}
    });

    ReportRepository.getLeasedAssetById(this.props.idReport, id)
      .then((response) => {
          this.initializeLeasedAsset(response);
          this.setState((prevState) => { return { keyModalLeasedAsset: `modalLeasedAsset_${new Date().getTime()}`, isEditModalLeasedAsset: true, isOpenModalLeasedAsset: true, editModelLeasedAsset: this.getItem(response)} });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.LEASEDASSET, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isSubmitted: false,
        });
      });
  };

  onRowColInputChange = (row, col, e) => {

    const newRow = { ...this.state.leasedAssetMatrix[row] };
    newRow[col] = e.target.value;
    const newStateEntry = { ...this.state.leasedAssetMatrix};
    newStateEntry[row] = newRow;

    this.setState((prevState) => {return {leasedAssetMatrix: newStateEntry}});
  };

  onUpdateInputChange = (inputName, inputValue) => {
    const statusCopy = { ...this.state.editModelLeasedAsset };
		statusCopy[inputName] = inputValue;

		this.setState((prevState) => {return {editModelLeasedAsset: statusCopy}});
  }

  destructureLeasedAssetMatrix(obj, fillEmptyFields) {
    const result = [];
    let containsEmptyFields = false;
    Object.keys(obj).forEach((key1) => {
      Object.keys(obj[key1]).forEach((key2) => {
        if (!fillEmptyFields && (obj[key1][key2] === undefined || obj[key1][key2] === '' || obj[key1][key2] === null)) {
          containsEmptyFields = true;
        } else {
          obj[key1][key2] = obj[key1][key2] || 0;
          result.push({
            idEnergySourceType: key1,
            idEnergyUsageType: key2,
            idLeasedAssetReportData: this.state.editModelLeasedAsset.id,
            value: obj[key1][key2],
          });
        }
      });
    });
    return containsEmptyFields ? null : result;
  }

  onSaveModalLeasedAsset = (fillEmptyFields) => {
    if (this.validator.allValid()) {

      // Destructure data in order to make it compatible with BE DTO types
      const leasedAssetMatrixDestructure = this.destructureLeasedAssetMatrix(this.state.leasedAssetMatrix, fillEmptyFields);

      const containEmptyFields =
        !fillEmptyFields && (leasedAssetMatrixDestructure === null)

      if (containEmptyFields) {
        this.toggleWarningModal();
        return;
      }

      const datiForm = {...this.state.editModelLeasedAsset, leasedAsset: leasedAssetMatrixDestructure};

      if (!this.state.isEditModalLeasedAsset) {
        datiForm["idReportEnvironment"] = this.props.idReportEnvironment;
      }
  
      this.setState({ isSubmitted: true/*, isLoadingSubmitted: true*/ });

      const method = this.state.isEditModalLeasedAsset ? 
        ReportRepository.updateLeasedAssetReportData(this.props.idReport, datiForm) 
        : ReportRepository.createLeasedAssetReportData(this.props.idReport, datiForm);

        method.then((response) => {
          //ReportRepository.updateCachedEnvironment(this.props.match.params.idReport, dto);

          this.updateListLeasedAssetReportData(response.data);
/*           if (!this.state.isEditModalLeasedAsset) {
            this.updatePagination();
          } */

          this.setState(() => {
            return {
              isOpenModalLeasedAsset: false,
              keyModalLeasedAsset: `modalLeasedAsset_${new Date().getTime()}`,
            };
          });

          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.LEASEDASSET, apioperation.PUT)
          );
        })
        .catch((error) => {
          showNotification.error(
            `${entitiesLabels.ERROR}`,
            getError(error, entitiesLabels.LEASEDASSET, apioperation.PUT)
          );
        })
        .finally(() => {
          this.setState({
            isSubmitted: false,
            /*isLoadingSubmitted: false,*/
          });
        });
    } 
    else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`, 'field not valid');
      this.forceUpdate();
    }
  };

/*
  updatePagination = async () => {
    await this.setState(() => ({
      addCountItems: this.state.addCountItems + 1,
    }));
  };
*/
  showLoading() {
    const show = this.state.isSubmitted;
    const descr = this.state.isOpenModalLeasedAsset ? 'Saving...' : 'Loading data...';
    return show && <Loading active withOverlay description={descr} />;
  }



  confirmDeleteLeasedAssetReportData = (id) => {
    this.setState({
      idToDelete: id,
      isOpenDeleteModal: true,
      isDeleting: false,
    });
  };

  onCloseDeleteConfirm = () => {
    this.setState({
      isOpenDeleteModal: false,
    });
  };

  deleteItemLeasedAssetReportData = () => {
    const id = this.state.idToDelete;

    this.setState({
      isDeleting: true,
    });

    ReportRepository.deleteLeasedAssetReportData(this.props.idReport, id)
      .then((response) => {
        if (response.status == 200) {
          this.setState({
            idToDelete: null,
            isOpenDeleteModal: false,
          });
          this.onCloseDeleteConfirm();
          this.updateListLeasedAssetReportData(id);
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.LEASEDASSET, apioperation.DELETE)
          );
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.LEASEDASSET, apioperation.DELETE)
        );
      })
      .finally(() => {
        this.setState({
          isDeleting: false,
        });
      });
  };
  
  render() {
    const rows = this.state.leasedAssetList || [];

    const leasedAssetRows = this.props.leasedAssetSchema.rows
    .filter((r) => !r.informativeonly)
    .map((r) => {
      let total = 0;
      this.props.leasedAssetSchema.cols.forEach(
        (c) => (total += (this.state.leasedAssetMatrix ? (+this.state.leasedAssetMatrix[r.id][c.id] || 0) : 0))
      );
      return {
        id: r.id,
        label: r.name,
        total,
        unit: r.name === 'Natural gas(methane)' ? 'NM3' : 'TON',
      };
    });
    const grandTotal = leasedAssetRows.map((w) => w.total).reduce((acc, cur) => (acc += cur), 0);

    const leasedAssetInformativeRows = this.props.leasedAssetSchema.rows
      .filter((r) => r.informativeonly)
      .map((r) => ({ id: r.id, label: r.name, unit: 'KWh', total: null }));

    const leasedAssetValidations = {};

    this.props.leasedAssetSchema.rows.forEach((r) => {
      leasedAssetValidations[r.id] = {};
      this.props.leasedAssetSchema.cols.forEach((c) => {
        leasedAssetValidations[r.id][c.id] = this.validator.message(
          `leasedAsset${r.id}${c.id}`,
          (this.state.leasedAssetMatrix ? this.state.leasedAssetMatrix[r.id][c.id] : 0),
          'geq'
        );
      });
    });

    const nameLeasedAssetValidation = this.validator.message('Name', (this.state.editModelLeasedAsset ? this.state.editModelLeasedAsset.name: ''),   'req');
    
    const LeasedAssetModalProps = {
      key: this.state.keyModalLeasedAsset,
      title: 'Leased Asset',
      editModel: this.state.editModelLeasedAsset,
      isOpenModal: this.state.isOpenModalLeasedAsset,
      isEditModal: this.state.isEditModalLeasedAsset,
      toggleModal: this.toggleModalLeasedAsset,
      toggleWarningModal : this.toggleWarningModal,
      isWarningModalOpen : this.state.isWarningModalOpen,
      onRowColInputChange: this.onRowColInputChange,
      onUpdateInputChange: this.onUpdateInputChange,
      save: this.onSaveModalLeasedAsset,
      handleConfirmSubmit: this.handleConfirmSubmit,
      leasedAssetMatrix : this.state.leasedAssetMatrix,
      leasedAssetHeaders: this.props.leasedAssetHeaders,
      leasedAssetInformativeHeaders: this.props.leasedAssetInformativeHeaders,
      leasedAssetRows: leasedAssetRows,
      leasedAssetInformativeRows: leasedAssetInformativeRows,
      grandTotal: grandTotal,
      leasedAssetValidations : leasedAssetValidations,
      nameLeasedAssetValidation : nameLeasedAssetValidation
    };
/*
   

        const paginationProps = () => ({
      page: this.props.currentPage || 1,
      totalItems: this.props.rowCount + this.state.addCountItems || 0,
      pageSize: this.props.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.props.handleChangePaging,
    });
    */
    const getNameLeasedAssetReportDataById = (id) => {
      if (id == null) return '';
      const element = rows.find((el) => el.id == id);
      return element && element.name ? element.name : '';
    };

    const confirmDelProps = () => ({
      idToDelete: this.state.idToDelete,
      nameItem: getNameLeasedAssetReportDataById(this.state.idToDelete),
      isDeleting: this.state.isDeleting,
      open: this.state.isOpenDeleteModal, // open state
      onCloseConfirm: this.onCloseDeleteConfirm, // no click
      deleteItem: this.deleteItemLeasedAssetReportData, // yes click fn()
    });
    

    const colSpan = 2;
    // partial page
    return (
      <>
        <ConfirmAlertCustom {...confirmDelProps()} />
        <div className="bx--row container-page">
          {this.showLoading()}
          <div className="bx--col-lg-12 bx--col-md-12 container-page">
            <div>
              <h3 className="title--medium--expressive">
                Leased Asset
              </h3>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-12 container-page">
                <TableToolbar>
                  <h3 className="title--medium max-width" />
                  {/* RITM1596906 */}
                  {!this.props.isDisabled && (
                    <Button onClick={() => this.addLeasedAsset()} renderIcon={Add16}>
                      Add a new leased asset
                    </Button>
                  )}
                  {/* End */}
                </TableToolbar>

                <TableContainer className="bx--grid--full-width">
                  {this.props.isLoading ? (
                    <DataTableSkeleton headers={[]} rowCount={10} zebra={false} compact={false} />
                  ) : (
                    <Table>
                      <TableHead className="colorgray">
                        <TableRow>
                          <TableHeader>Name</TableHeader>
                          <TableHeader className="align-center">Actions</TableHeader>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows == null || rows.length == 0 ? (
                          <NoRecordsPlaceholder labelText="No Records" colSpan={colSpan} />
                        ) : (
                          rows.map((item) => (
                            <TableRow key={`row_${item.id}`}>
                              <TableCell key={`cell_fullname_${item.id}`}>
                                {item.name}
                              </TableCell>
                              <TableCell
                                key={`action-${item.id}`}
                                className="tableActions align-center"
                              >
                                {/* RITM1596906 */}
                                {!this.props.isDisabled && (
                                <div>
                                  <Button
                                    onClick={() => this.editModalLeasedAsset(item.id)}
                                    size="small"
                                    renderIcon={Edit16}
                                    iconDescription="Edit"
                                    kind="ghost"
                                  />
                                  <Online>
                                    
                                      <Button
                                        onClick={() => this.confirmDeleteLeasedAssetReportData(item.id)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                      />
                                    
                                  </Online>
                                </div>
                                )}
                                {/* End */}
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  )}
                </TableContainer>
                <div className="footer-pagination">
                  {/*<Pagination {...paginationProps()} />*/}
                </div>
                {<EnergyAccountLeasedAssetModal {...LeasedAssetModalProps} />}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
